import React, { forwardRef } from 'react';
import { styled, ThemeProvider, useTheme } from 'src/packages/theme';
import { system, compose, flexbox } from 'styled-system';

import { FlexProps } from './Flex.types';
import { space, BaseBox } from 'src/packages';

const gridRow = system({
  gridRow: {
    property: 'gridRow',
    scale: 'space',
    defaultScale: space,
  },
});

const gridColumn = system({
  gridColumn: {
    property: 'gridColumn',
    scale: 'space',
    defaultScale: space,
  },
});

const StyledFlex = styled((props) => <BaseBox {...props} />)<FlexProps>(
  {
    display: 'flex',
    direction: 'ltr',
  },
  compose(flexbox, gridRow, gridColumn)
);

const Flex = forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
  const contextTheme = useTheme();
  const { onClick = undefined, children, style = {}, theme, ...rest } = props;

  return (
    <ThemeProvider theme={theme} rtl={contextTheme.rtl}>
      <StyledFlex
        ref={ref}
        onClick={() => {
          typeof onClick === 'function' && onClick();
        }}
        style={style}
        {...rest}
      >
        {children}
      </StyledFlex>
    </ThemeProvider>
  );
});

export default Flex;
